import { observer } from 'mobx-react-lite'
import i from '../../translations/i'
import { Titles } from '../../layouts/Titles'
import controller from './contacts.controller'
import { Button, Pagination, Space, Table, Tag, Row, Col, Input, Select, Switch } from "antd";
import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { ParamTypes } from '../../helpers/types.interfaces'
import { WarehousesController } from "../settings/warehouses/warehouses.controller";
import projectController from "../settings/project/project.controller";
import { canManageOwnedRecord } from "../../helpers/manager_ownership";
import { storeLocal } from "../../helpers/stores";

const Storage = new WarehousesController()
export const Contact = observer(() => {

    const { elementID } = useParams<ParamTypes>()
    const isFranchisee = storeLocal.get('role') === 6
    const allowedWarehouseIds: number[] = storeLocal.get('warehouses_access') || []

    useEffect(() => {
      Storage.pagination.limit = 999
      Storage.get()
        if(elementID) controller.get(Number(elementID))
    }, [])

    useEffect(() => {
        if (isFranchisee && !Number(elementID) && !controller.element.warehouse_id && allowedWarehouseIds.length > 0) {
            controller.element.warehouse_id = allowedWarehouseIds[0]
        }
    }, [])

    // Уже привязанный к контакту склад показываем с названием, даже если он вне текущего
    // доступа франчайзи - иначе Select рисует голый ID вместо label. Выбрать новый чужой
    // склад при этом всё равно нельзя.
    const warehousesList = isFranchisee
      ? [
          ...Storage.list.filter((el: any) => allowedWarehouseIds.includes(el.id)),
          ...Storage.list.filter((el: any) => el.id === controller.element.warehouse_id && !allowedWarehouseIds.includes(el.id))
        ]
      : Storage.list

    const buttons = [
        { title: i.t('def:actions.backList'), href: `/contacts`, type: 'dashed' },
        { title: i.t('def:actions.save'), htmlType: `submit`, type: 'primary' }
    ]

    return(
        <>
            <form onSubmit={(e) => controller.save(e)}>
                <Titles
                    title={i.t('contacts:titleDetail')}
                    buttons={buttons}
                />

                <Row gutter={[20, 20]}>
                  <Col span={24}>
                    <div className="switch-block">
                      <div className="element">
                        <div></div>
                        <Switch
                          checked={controller.element.to_order}
                          onChange={e => controller.element.to_order = e}
                          size="small"
                        />
                        <div>
                          <span>{i.t('modifiersGroup:forOrders')}</span>
                        </div>
                      </div>
                    </div>
                  </Col>
                    <Col xs={{ span: 24 }} md={{ span: 8 }}>
                        <label>{i.t('contacts:form.title')}</label>
                        <Input
                            name="title"
                            placeholder={i.t('contacts:form.title')}
                            value={controller.element.title}
                            onChange={(e) => controller.set('title', e.target.value)}
                        />
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 8 }}>
                        <label>{i.t('contacts:form.type')}</label>
                        <Select
                            style={{ width: '100%' }}
                            value={controller.element.type}
                            placeholder={i.t('contacts:form.type')}
                            onChange={(e) => controller.set('type', e)}
                        >
                            {controller.types.map(el => (
                                <Select.Option
                                    key={`contact_select_${el.name}`}
                                    value={el.name}
                                >
                                    { el.description }
                                </Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 8 }}>
                      <label>{i.t('contacts:selectWarehouse')}</label>
                      <Select
                        value={controller.element.warehouse_id}
                        style={{ width: "100%" }}
                        onChange={(e) =>  controller.set('warehouse_id', e)}
                      >
                        {!isFranchisee && <Select.Option value={null}>{i.t("constructor:storages")}</Select.Option>}
                        {warehousesList.map((item: any) => (
                          <Select.Option value={item.id} key={item.id}>{item.name}</Select.Option>
                        ))}
                      </Select>
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 24 }}>
                        <label>{i.t('contacts:form.value')}</label>
                        <Input.TextArea
                            placeholder={i.t('contacts:form.value')}
                            value={controller.element.value}
                            onChange={(e) => controller.set('value', e.target.value)}
                        />
                    </Col>
                </Row>
            </form>
        </>
    )
})

export const Contacts = observer(() => {

    const isFranchisee = storeLocal.get('role') === 6
    const allowedWarehouseIds: number[] = storeLocal.get('warehouses_access') || []

    useEffect(() => {
      Storage.pagination.limit = 999
      Storage.get()

      if (isFranchisee && allowedWarehouseIds.length > 0) {
        controller.setWarehouse(allowedWarehouseIds[0])
      } else {
        controller.get()
      }
    }, [])

    const warehousesList = isFranchisee ? Storage.list.filter((el: any) => allowedWarehouseIds.includes(el.id)) : Storage.list

    const buttons = [
        { title: i.t('def:actions.create'), href: `/contacts/0`, type: 'primary' }
    ]

    const columns = [
        { title: 'ID', dataIndex: 'id', key: 'id' },
        { title: i.t('def:name'), dataIndex: 'title', key: 'title' },
        { title: i.t('def:actions.type'), dataIndex: 'type', key: 'type', render: (el: any) => <Tag>{controller.getTypeByName(el)}</Tag> },
        { title: i.t('def:actions.value'), dataIndex: 'value', key: 'value' },
        {
            key: 'action',
            render: (text: any, record: any) => (
                <Space size="middle">
                    <Button
                        type="dashed"
                        shape="circle"
                        icon={<EditOutlined />}
                        href={`/contacts/${record.id}`}
                        disabled={!canManageOwnedRecord(record)}
                    />
                    <Button
                        type="dashed"
                        shape="circle"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => controller.remove(record.id)}
                        disabled={!canManageOwnedRecord(record)}
                    />
                </Space>
            )
        }
    ]

    return(
        <>
            <Titles
                title={i.t('contacts:title')}
                buttons={buttons}
            />

          <Row gutter={[20, 20]}>
            <Col span={24}>
              <Select
                value={controller.selectedWarehouse > 0 ? controller.selectedWarehouse : null}
                style={{ width: "250px" }}
                onChange={(e) => controller.setWarehouse(e)}
              >
                {!isFranchisee && <Select.Option value={null}>{i.t("constructor:storages")}</Select.Option>}
                {warehousesList.map((item: any) => (
                  <Select.Option value={item.id} key={item.id}>{item.name}</Select.Option>
                ))}
              </Select>
            </Col>
            <Col span={24}>
              <Table
                columns={columns}
                dataSource={controller.list}
                rowKey="id"
                pagination={false}
              />
              <br />
              <Pagination
                defaultCurrent={controller.pagination.page}
                current={controller.pagination.page}
                defaultPageSize={controller.pagination.limit}
                pageSize={controller.pagination.limit}
                total={controller.pagination.total}
                showSizeChanger={false}
                onChange={(e) => controller.setPage(e)}
              />
            </Col>
          </Row>
        </>
    )
})